import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CourseViewModel, AssessmentViewModel, AssessmentResponsesViewModel, CourseCompletionViewModel } from 'src/app/_models/generatedModels';
import { AssessmentService, CourseService } from 'src/app/_services/generatedServices';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToasterService } from 'src/app/_services/toaster.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'bxl-ceu-assessment',
  templateUrl: 'ceu-assessment.component.html',
})
export class CeuAssessmentComponent implements OnInit {
  initialized = false;
  currentQuestion = 0;
  public ceuError: string;

  @Output()
  closed = new EventEmitter();

  assessmentForm: FormGroup;
  @Input() course: CourseViewModel;
  assessment: AssessmentViewModel;
  public completionStatus: CourseCompletionViewModel;
  notRegistered: boolean;

  constructor(private assessmentService: AssessmentService, public activeModal: NgbActiveModal, private auth: AuthenticationService, private toaster: ToasterService, private courseData: CourseService, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.assessmentService.getAssessment(this.course.assessmentId).subscribe((result) => {
      this.completionStatus = new CourseCompletionViewModel();
      this.courseData.getCourseUserCompletionStatus(this.course.id).subscribe((completion) => {
        this.completionStatus = completion;
        this.assessment = result;
        this.loadAssessment();
        this.initialized = true;
      }, error=>{
        this.completionStatus = null;
        this.notRegistered = true;
        console.log('not registered');
        this.initialized = true;
      });
    });
  }

  loadAssessment() {
    let questions = this.assessment.questions.map((x) =>
      this.fb.group({
        text: x.text,
        questionId: x.id,
        responseId: null,
      })
    );

    this.assessmentForm = this.fb.group({
      questions: this.fb.array(questions),
      rating: [null, [Validators.required]],
      text: ['', [Validators.required]],
    });

    this.initialized = true;
  }
  close() {
    this.activeModal.close();
    console.log('close');
    this.closed.emit();
  }

  submitAssessment() {
    if (!this.assessmentForm.valid) {
      this.assessmentForm.markAllControlsDirty();
      this.toaster.error('Please fill out all required fields', 'Error');
      return;
    }
    const formData: AssessmentResponsesViewModel = Object.assign({}, null, this.assessmentForm.value);
    formData.responses = this.assessmentForm.value.questions;

    this.assessmentService.submitAssessmentAndGetCeus(this.course.id, formData).subscribe(
      (result) => {
        this.ceuError = null;
        this.completionStatus = result;

        this.toaster.messageDialog('This event is complete. You can download your certificate from "CEU History" of "My Account"', 'Event Complete').subscribe();
        this.activeModal.dismiss();
      },
      (error) => {
        this.ceuError = error.error[0];
      }
    );
  }
}
